import { MenuItem } from "./menu.model";
import { Modules } from "../../../core/model/modules.enum";
import { Privileges } from "../../../core/model/privileges.enum";
import { AuthService } from "../../../providers/auth.service";
import { environment } from "src/environments/environment";

/** Dejaup URL from Portal sidebar (`rel="opener"` so VMS can treat the new tab as a trusted open). */
function dejaupAppUrlFromPortal(): string {
  try {
    const base = environment.vipUrl.replace(/\/$/, "");
    return `${base}/terminals`;
  } catch {
    return environment.vipUrl;
  }
}

export const MENU: MenuItem[] = [
  {
    label: "Main",
    isTitle: true,
    module: Modules.COMMON,
  },
  {
    label: "Dashboard",
    icon: "grid",
    link: "/dashboardv2",
    module: Modules.DASHBOARD,
    privilege: Privileges.VIEW_DASHBOARD,
    indexId: 0,
    isMobileView: true
  },
  {
    label: "UserManagement",
    icon: "users",
    link: "/user-management/users/",
    module: Modules.USER,
    privilege: Privileges.VIEW_USER,
    indexId: 1,
    isMobileView: true
  },
  {
    label: "Customer",
    icon: "user-plus",
    link: "/customer-management/customers/",
    module: Modules.CUSTOMER,
    privilege: Privileges.VIEW_CUSTOMER,
    indexId: 2,
    isMobileView: false
  },
  {
    label: "ISV",
    icon: "user",
    link: "/isv-management/isv/",
    module: Modules.ISV,
    privilege: Privileges.VIEW_ISV,
    indexId: 2.1,
    isMobileView: false
  },
  {
    label: "Merchants",
    icon: "users",
    link: "/merchant-management/list-merchant/",
    module: Modules.MERCHANT,
    privilege: Privileges.VIEW_MERCHANT,
    indexId: 3,
    isMobileView: true
  },
  // {
  //   label: "Params",
  //   icon: "layers",
  //   link: "/params-management/add-params/",
  //   module: Modules.USER,
  //   indexId: 3,
  // },
  {
    label: "STEAM",
    icon: "smartphone",
    module: Modules.STEAM,
    link: "/application-management/list-device/",
    indexId: 4,
    isMobileView: true,
    subItems: [
      {
        label: "Application",
        privilege: Privileges.VIEW_APPLICATION,
        link: "/application-management/list-application/",
        module: Modules.STEAM,
        isMobileView: false
      },
      // {
      //   label: "Manage DvStore",
      //   privilege: Privileges.VIEW_MARKET_APP,
      //   link: "/manage-market-app/list-apps/",
      //   module: Modules.STEAM,
      //   isMobileView: false
      // },
      {
        label: "Edit Parameters",
        privilege: Privileges.VIEW_DEVICE,
        link: "/steam-param/list-device/",
        module: Modules.STEAM,
        isMobileView: true        
      },
      {
        label: "Non-Gateway TPNs",
        privilege: Privileges.VIEW_NON_GATEWAY_TPN,
        link: "/non-gateway-web/tpn/",
        module: Modules.STEAM,
        isMobileView: false
      },
      {
        label: "Assets",
        privilege: Privileges.VIEW_ASSETS,
        link: "/asset-management/list-asset/",
        module: Modules.STEAM,
        isMobileView: false      
      },
      {
        label: "Download Logs",
        privilege: Privileges.VIEW_DOWNLOAD_LOG,
        link: "/downloadlog-management/list-downloadlog",
        module: Modules.STEAM,    
        isMobileView: false    
      },
      {
        label: "Device Alerts",
        module: Modules.STEAM,
        privilege: Privileges.VIEW_DEVICE_ALERT,
        link: "device-alert-management/list-devicealert",
        isMobileView: false
      },
      {
        label: "Audit Logs",
        // module: Modules.STEAM,
        // privilege: Privileges.VIEW_DEVICE_ALERT,
        module: Modules.STEAM,
        privilege: Privileges.VIEW_AUDITLOGS,
        link: "app-auditlog-list/list-auditlog",
        isMobileView: false
      },
      {
        label: "Proxy Login",
        // module: Modules.STEAM,
        // privilege: Privileges.VIEW_DEVICE_ALERT,
        module: Modules.STEAM,
        privilege: Privileges.VIEW_PROXY_LOGS,
        link: "proxy-login-logs",
        isMobileView: false
      },
      {
        label: "Bulk Assign Build",
        privilege: Privileges.BULK_ASSIGN,
        link: "/advanced/bulk-assign",
        module: Modules.STEAM,
        isMobileView: false
      }
    ],
  },
    {
    label: "Control Center",
    icon: "sliders",
    link: "communication-center",
    module: Modules.COMMUNICATION_CENTER,
    privilege: Privileges.SEND_COMMUNICATION,
    indexId: 4.2,
    isMobileView: false,
    moduleGroup: Modules.CONTROL_CENTER
  },
  {
    label: "Control Center",
    icon: "sliders",
    link: "communication-center",
    module: Modules.COMMAND_CENTER,
    privilege: Privileges.SEND_COMMAND,
    indexId: 4.1,
    isMobileView: false,
    moduleGroup: Modules.CONTROL_CENTER
  },

  {
    label: "DvStore",
    icon: "shopping-cart",
    module: Modules.DV_STORE,
    link: "/application-management/list-device/",
    indexId: 5,
    isMobileView: true,
    subItems: [
      {
        label: "My Applications",
        privilege: Privileges.MY_APP_VIEW,
        link: "/dv-store/my-applications/app-dashboard",
        module: Modules.DV_STORE,
        isMobileView: true
      },
      {
        label: "Manage DvStore",
        privilege: Privileges.MANAGE_DVSTORE,
        link: "/manage-market-app/list-apps/",
        module: Modules.DV_STORE,
        isMobileView: false
      },
      {
        label: "Value-Added Apps",
        privilege: Privileges.VALUE_ADDED_APPS,
        link: "/dv-store/list-apps/",
        module: Modules.DV_STORE,
        isMobileView: true
      },
    ],
  },
  {
    label: "Transactions",
    icon: "layers",
    link: "/transaction-management/transactions/",
    module: Modules.TRANSACTION,
    privilege: Privileges.VIEW_TRANSACTION,
    indexId: 6,
    isMobileView: true
  },
  // {
  //   label: "Merchants",
  //   icon: "users",
  //   link: "/merchant-management/list-merchant/",
  //   module: Modules.MERCHANT,
  //   privilege: Privileges.VIEW_MERCHANT,
  //   indexId: 6
  // },
  // {
  //   label: "CloudPOS",
  //   icon: "credit-card",
  //   link: "/virtual-terminal/list",
  //   module: Modules.CLOUD_POS,
  //   privilege: Privileges.PAYMENTS,
  //   indexId: 6,
  // },
  {
    label: "CloudPOS",
    icon: "credit-card",
    module: Modules.CLOUD_POS,
    link: "/virtual-terminal/list",
    isMobileView: true,
    indexId: 7,
    subItems: [
      {
        label: "Payments",
        privilege: Privileges.PAYMENTS,
        link: "/virtual-terminal/list",
        module: Modules.CLOUD_POS,
        isMobileView: true
      },
      {
        label: "Invoices",
        privilege: Privileges.VIEW_INVOICE_LIST,
        link: "/virtual-terminal/invoice-list",
        module: Modules.CLOUD_POS,
        isMobileView: false
      },
      {
        label: "Recurring Payments",
        privilege: Privileges.VIEW_RECURRING_PAYMENT_LIST,
        link: "/virtual-terminal/recurring-payment-list",
        module: Modules.CLOUD_POS,
        isMobileView: false
      }
    ],
  },
  {
    label: "My Customers",
    icon: "user",
    link: "consumer-list/list",
    module: Modules.CONSUMER,
    privilege: Privileges.VIEW_CONSUMER,
    indexId: 9,
    isMobileView: false
  },
  {
    label: "Batches",
    icon: "file-minus",
    link: "/batch-management/batches",
    module: Modules.BATCHES,
    privilege: Privileges.VIEW_BATCHES,
    indexId: 8,
    isMobileView: true
  },
  {
    label: "My Tickets",
    icon: "inbox",
    link: "/my-tickets/my-ticket-list",
    module: Modules.MY_TICKETS,
    privilege: Privileges.VIEW_TICKET,
    indexId: 10,
    isMobileView: false
  },
  {
      label: "Settings",
      icon: "settings",
      module: Modules.MERCHANT_SETTINGS,
      privilege: Privileges.ADD_PROMOTIONAL_SETTING,
      link: "/merchant-settings/settings",
      indexId: 11,
      isMobileView: false
  },
  {
    label: "Settings",
    icon: "settings",
    module: Modules.ISO_SETTINGS,
    privilege: Privileges.HELP_DESK,
    link: "/customer-settings/settings",
    indexId: 12,
    isMobileView: false
  },
  {
    label: "Settings",
    icon: "settings",
    module: Modules.ISV_SETTINGS,
    privilege: Privileges.HELP_DESK,
    link: "/isv-settings/settings",
    indexId: 12,
    isMobileView: false
  },
  {
    label: "Digital Ads",
    icon: "message-circle",
    privilege: Privileges.VIEW_PROMOTION,
    module: Modules.PROMOTION,
    link: "/promotions",
    isMobileView: false
  },

  {
    label: "Reports",
    icon: "message-circle",
    module: Modules.REPORTS,
    isMobileView: false,
    subItems: [
      {
        label: "Tip Report",
        privilege: Privileges.VIEW_TIP_REPORT,
        link: "/reports/tip-report",
        module: Modules.REPORTS,
        isMobileView: false
      },
      {
        label: "Batch Report",
        privilege: Privileges.VIEW_BATCH_REPORT,
        link: "/reports/settlement-report",
        module: Modules.REPORTS,
        isMobileView: false
      },
      {
        label: "Register Lite Report",
        privilege: Privileges.VIEW_BATCH_REPORT,
        link: "/reports/inventory-report",
        module: Modules.REPORTS,
        isMobileView: false
      }

    ]
  },
  {
    label: "Digital Ads",
    icon: "airplay",
    module: Modules.CAMPAIGN,
    isMobileView: false,
    subItems: [
      {
        label: "Digital Ad On Screen",
        privilege: Privileges.VIEW_CAMPAIGN,
        link: "/digital-ads-on-screen",
        module: Modules.CAMPAIGN,
        isMobileView: false
      }
    ]
  },

  {
    label: "iPOS S.A.F.E",
    icon: "shield",
    module: Modules.RISK_MANAGEMENT,
    indexId: 13,
    isMobileView: false,
    subItems: [
      {
        label: "Risk rules",
        privilege: Privileges.VIEW_RISK_DETAILS,
        link: "/risk-management/list",
        module: Modules.RISK_MANAGEMENT,
        isMobileView: false
      },
      {
        label: "Templates",
        privilege: Privileges.VIEW_RISK_TEMPLATES,
        link: "/risk-management/templates",
        module: Modules.RISK_MANAGEMENT,
        isMobileView: false
      }
    ]
  },
  {
    icon: "file-text",
    label: "Register Lite",
    privilege: Privileges.VIEW_INVENTORY,
    module: Modules.INVENTORY,
    link: "/inventory",
    isMobileView: false
  },


  {
    label: "Troubleshooting",
    icon: "airplay",
    module: Modules.TROUBLESHOOT,
    link: "/spin-troubleshooting/spin-proxy",
    isMobileView: false,
    indexId: 14,
    subItems: [
      {
        label: "Spin Proxy",
        privilege: Privileges.SPIN_PROXY,
        link: "/spin-troubleshooting/spin-proxy",
        module: Modules.TROUBLESHOOT,
        isMobileView: false
      }
    ],
  },
  {
    label: "Resources",
    icon: "package",
    module: Modules.RESOURCES,
    isMobileView: false,
    indexId: 15,
    subItems: [
      {
        label: "API Docs",
        privilege: Privileges.API_DOCS,
        link: environment.apiDocsLink,
        target: "_blank",
        isExternalURL: true,
        module: Modules.RESOURCES,
        isMobileView: false
      },
       {
        label: "Knowledge Base",
        privilege: Privileges.KNOWLEDGE_BASE,
        link: environment.knowledgeBaseLink,
        target: "_blank",
        isExternalURL: true,
        module: Modules.RESOURCES,
        isMobileView: false
      },
      {
        label: "Release Notes",
        privilege: Privileges.RELEASE_NOTES,
        link: environment.releaseNotesLink,
        target: "_blank",
        isExternalURL: true,
        module: Modules.RESOURCES,
        isMobileView: false
      }
    ],
  },
  {
    label:"Invoices",
    icon:"file-text",
    privilege: Privileges.VIEW_INVOICE,
    module: Modules.BILLING,
    isMobileView: false,
    link:"/billing-invoice",
    subItems: [
      {
        label: "Transaction",
        privilege: Privileges.VIEW_INVOICE,
        link: "/billing-invoice/TXN",
        module: Modules.BILLING,
        isMobileView: false
      },
      {
        label: "Rental",
        privilege: Privileges.VIEW_INVOICE,
        link: "/billing-invoice/RENTAL",
        module: Modules.BILLING,
        isMobileView: false
      },
      {
        label: "Merchant Invoicing",
        privilege: Privileges.VIEW_INVOICE,
        link: "/billing-invoice/m-b",
        module: Modules.BILLING,
        isMobileView: false
      }

    ]
  },
  // {
  //   label: "Developer Central",
  //   icon: "code",
  //   module: Modules.DEVELOPER_CENTER,
  //   privilege: Privileges.EXTERNAL_DOCUMENT,
  //   link: environment.developerLink,
  //   isMobileView: false,
  //   indexId: 15,
  //   target:"_blank",
  //   isExternalURL:true,
  // },
  {
    label: "some menu",
    icon: "users",

    subItems: [
      {
        isUsers: true,
        label: "menu",
        link: "/user-management/users/",
      },
    ],
  },
  {
    label: "Videos",
    icon: "video",
    module: Modules.CUSTOMER_SUPPORT_VIDEOS,
    indexId: 16,
    subItems: [
      {
        label: "Training Videos",
        privilege: Privileges.VIEW_CUSTOMER_SUPPORT_VIDEOS,
        link: "https://www.youtube.com/@Dejavoo2006/playlists",
        module: Modules.CUSTOMER_SUPPORT_VIDEOS,
        target: "_blank",
        isExternalURL: true,
        isMobileView: false
      }
    ]
  },
  {
    label: "menuNames.dejaUp",
    icon: "briefcase",
    link: dejaupAppUrlFromPortal(),
    module: Modules.DEJAUP,
    // module: Modules.COMMAND_CENTER,
    privilege: Privileges.VIEW_TERMINAL,
    indexId: 17.1,
    isMobileView: false,
    target: "_blank",
    externalLinkRel: "opener",
    isExternalURL: true
  },
  {
    label: "menuNames.dejaUp",
    icon: "briefcase",
    link: dejaupAppUrlFromPortal(),
    module: Modules.DEJAUP,
    // module: Modules.COMMAND_CENTER,
    privilege: Privileges.VIEW_DISPENSER,
    indexId: 17.2,
    isMobileView: false,
    target: "_blank",
    externalLinkRel: "opener",
    isExternalURL: true
  },
  {
    label: "menuNames.dejaUp",
    icon: "briefcase",
    link: dejaupAppUrlFromPortal(),
    module: Modules.DEJAUP,
    // module: Modules.COMMAND_CENTER,
    privilege: Privileges.VIEW_DEX_AUDIT,
    indexId: 17.3,
    isMobileView: false,
    target: "_blank",
    externalLinkRel: "opener",
    isExternalURL: true
  },
  {
    label: "menuNames.dejaUp",
    icon: "briefcase",
    link: dejaupAppUrlFromPortal(),
    module: Modules.DEJAUP,
    // module: Modules.COMMAND_CENTER,
    privilege: Privileges.VIEW_WEBHOOK_LOG,
    indexId: 17.4,
    isMobileView: false,
    target: "_blank",
    externalLinkRel: "opener",
    isExternalURL: true
  },
  {
    label: "menuNames.dejaUp",
    icon: "briefcase",
    link: dejaupAppUrlFromPortal(),
    module: Modules.DEJAUP,
    // module: Modules.COMMAND_CENTER,
    privilege: Privileges.VIEW_WEBHOOK,
    indexId: 17.5,
    isMobileView: false,
    target: "_blank",
    externalLinkRel: "opener",
    isExternalURL: true
  }
];
